import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export type SearchResult = {
  id: string
  type: string
  metadata?: string
  related?: SearchResult[]
  persisted: boolean
}

export type ModelTypesState = {
  user: boolean
  employer: boolean
  employee: boolean
  member: boolean
  employerAdmin: boolean
  partner: boolean
  partnerAdmin: boolean
  prospect: boolean
}

export type ModelTypes = 'User' | 'Employer' | 'Employee' | 'Member' | 'Employer Admin' | 'Partner' | 'Partner Admin' | 'Prospect'

export function useThatchSearch ({ query, modelTypes }: {
  query: string,
  modelTypes: ModelTypesState
}) {
  return useQuery<SearchResult[], GrapeAPIErrorType>({
    queryKey: ['query', query, 'modelTypes', modelTypes],
    queryFn: async () => {
      const params = new URLSearchParams([
        ['query', query],
        ...Object.entries(modelTypes).map(([key, value]) => [key, value.toString()])
      ]).toString()

      const response = await fetchWithHeaders(`/api/web/admin/search?${params}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    enabled: !!query, // Only fetch if there is a query.
    retry: false,
  })
}
